<template>
  <div class="sticky top-0 z-50 bg-dark-gray container__div">
    <div>
      <div class="flex flex-wrap">
        <div class="section w-full pr-10">
          <div>
            <div class="flex mt-4 border-b-2">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 rounded px-5 title">
                  Introducción
                </h2>
              </div>
            </div>
            <p class="px-5 my-4 text-sm xl:text-base">
              Bienvenidos a la sección documentación de Mercado Flex. Aqui los
              pasos necesarios para poder realizar exitosamente tu registro en
              la plataforma y posteriormente hacer envíos con nosotros.
            </p>
            <p class="px-5 my-4 text-sm xl:text-base">
              Estos servicios se encuentran registrados en el dominio de Nirex.
            </p>
            <div class="flex mt-4 border-b-2 mt-5">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 px-5 title">
                  Autentificación
                </h2>
              </div>
            </div>

            <p class="px-5 text-sm xl:text-base py-3">
              Primero, debes crear tu cuenta como Empresa en :
            </p>
            <a
              class="px-5"
              href="https://programados.nirex.pe/auth/register"
              target="_blank"
              >https://programados.nirex.pe/auth/register</a
            >
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="require('@/assets/img/Dashboard/first-step.png')"
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 text-sm xl:text-base py-3">
              Luego nuestro equipo comercial te contactará y activará tu cuenta
              corporativa confirmando tus datos de acceso (E-Mail y Password).
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              Posteriormente, debes ingresar a
              <a href="https://programados.nirex.pe/auth/login" target="_blank"
                >https://programados.nirex.pe/auth/login</a
              >
              con las credenciales de acceso o en su defecto, recargar la
              página.
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              Una vez dentro, debes dirigirte a la sección CUENTA y agregar una
              tarjeta de crédito para poder vincularte.
            </p>
            <div class="flex mt-4 border-b-2">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 rounded px-5 title">
                  Añadir método de pago
                </h2>
              </div>
            </div>
            <p class="px-5 text-sm xl:text-base py-3">
              Habiendo llegado a tu vista de cuenta, puedes agregar una tarjeta.
              En el apartado de
              <img
                width="300"
                src="@/assets/img/Icons/add__card.png"
                alt="add card"
              />, haz clic y te aparecerá un modal cómo este.
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="require('@/assets/img/Icons/add__card__modal.png')"
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 text-sm xl:text-base py-3">
              Aquí puedes cargar los datos de tú tarjeta, te recomendamos que no
              sea del tipo token dinámico.
            </p>
          </div>
          <div>
            <div class="flex mt-4 border-b-2">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 rounded px-5 title">
                  Autorización y vinculación
                </h2>
              </div>
            </div>
            <p class="px-5 my-4 text-sm xl:text-base">
              Luego de haber culminado el proceso de vinculación de tu tarjeta,
              dirigete a la barra principal, en INTEGRACIONES y verás una vista
              cómo esta.
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="
                  require('@/assets/img/Step-By-Step-MF/integration__view.png')
                "
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 my-4 text-sm xl:text-base">
              En la tarjeta de Mercado envioflex, haz clic en
              <img
                width="180"
                src="@/assets/img/Step-By-Step-MF/integrar_tienda_button.png"
                alt="integrar_tienda"
              />, esto te lleavará a una ventana de confirmación de Mercado
              Libre.
            </p>
            <p class="px-5 my-4 text-sm xl:text-base">
              Mercado Libre pedirá por tus credenciales como tienda, tienes que
              aceptar los accesos para la aplicación de Nirex.
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="require('@/assets/img/Step-By-Step-MF/mercado_auth.png')"
                alt="Flujo de integración"
              />
            </div>

            <p class="px-5 text-sm xl:text-base py-3">
              Se te presentará una pantalla de carga y luego de ello volverás a
              la vista de integraciones, dónde tu tarjeta de Mercado Flex debe
              tener la vinculación ya realizada con un check.
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="require('@/assets/img/Step-By-Step-MF/sync_finished.png')"
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 text-sm xl:text-base py-3">
              Con esto tendrás todo completado y estarás listo para realizar
              pedidos desde nuestra plataforma.
            </p>
          </div>
          <div>
            <div class="flex mt-4 border-b-2">
              <div>
                <img src="@/assets/img/Icons/title_pattern.png" alt="" />
              </div>
              <div>
                <h2 class="text-3xl font-neue py-2 rounded px-5 title">
                  Uso del servicio
                </h2>
              </div>
            </div>
            <p class="px-5 my-4 text-sm xl:text-base">
              Estando ya integrado, puedes acceder a la pestaña de servicios e
              ingresar al servicio Mercado Flex.
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="
                  require('@/assets/img/Step-By-Step-MF/service_actived.png')
                "
                alt="Flujo de integración"
              />
            </div>
            <p class="px-5 my-4 text-sm xl:text-base">
              Das click en SOLICITAR y entrarás en la vista del servicio Mercado
              Flex
            </p>
            <div class="flex justify-center">
              <img
                class="my-10 flujo border-light-purple"
                :src="
                  require('@/assets/img/Step-By-Step-MF/main_view_service.png')
                "
                alt="Vista principal"
              />
            </div>

            <p class="px-5 text-sm xl:text-base py-3">
              Podrás ver las tarifas del servicio y un botón para seleccionar
              los pedidos que provienen de mercado flex. Serás capaz de ver el
              ID, quién es el comprador, su dirección y el estado del pedido.
              <img
                width="180"
                src="@/assets/img/Step-By-Step-MF/mf_button_load_orders.png"
                alt="seleccionar pedidos"
              />
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              Con esto tendrás los pedidos a tu disposición y podrás crear los
              pedidos que necesitos. Tienes como máximo 6 destinos elegibles.
              Recuerda que se cargará por defecto la dirección que hayas
              registrado en la plataforma (en el caso de no tenerlo, puedes ir a
              cuenta y agregarlo desde ahí).
            </p>
            <p class="px-5 text-sm xl:text-base py-3">
              No elimines el comentario del order id, ya que es necesario para
              la entrega de tu pedido.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.item {
  box-shadow: -1px 10px 17px -2px rgba(255, 0, 0, 0.11);
}

.container__div {
  max-width: 1360px;
  margin: 0 auto;

  @media only screen and (max-width: 1361px) {
    padding: 0 4%;
  }
}

.text-gray-nirex-footer {
  color: #333;
}

.bg-red-btn-nirex {
  background-color: #f33;
}

.code {
  background-color: #272936;
}

.code__container {
  width: 100%;
}

a,
a:link,
a:visited {
  text-decoration: none;
  color: #0A50E6;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}

tbody tr {
  background-color: #73c9ff;
}

tbody tr:nth-child(even) {
  background-color: #85a7f6;
  color: white;
}

thead {
  background-color: #85a7f6;
}
</style>
